import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import style from "./ilifepoint.module.scss";
import { CurrencyDecimalFormat } from "../../helper";

function Tiles(props) {
  console.log("tiles data goes here", props);
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const Currency = useSelector((state) => state.curr);

  return (
    <div className={`${style.ewalletTiles} ${style.center}`}>
      {props.tilesData.map((tiles, index) => (
        <div
          className={`${
            currentTheme === "theme-dark"
              ? `${style.dark_mode_Tiles} d-flex`
              : `${style.Tiles} d-flex`
          }`}
          key={index}
        >
          <div
            className={`${
              currentTheme === "theme-dark"
                ? `${style.dark_mode_tilesData}`
                : `${style.tilesData}`
            }`}
          >
            <h4>
              <strong>Total PV For The Month</strong>
            </h4>
            <br />
            <input
              type="text"
              className={`${style.TilesAmount} ${style.centerInput}`}
              value={tiles.amount}
              readOnly
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default Tiles;